"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pUnitFromData = void 0;
var phoist_1 = require("../../phoist.js");
var plam_1 = require("../../plam.js");
var pmakeUnit_1 = require("./pmakeUnit.js");
var types_1 = require("../../../type_system/types.js");
exports.pUnitFromData = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.data, types_1.unit)(function (_) { return (0, pmakeUnit_1.pmakeUnit)(); }));
